import echarts from 'echarts'
import filters from '@/filters'
var option = {
  backgroundColor: "rgba(0,0,0,0)",
  tooltip: {
    trigger: 'axis',
    show: false,
    axisPointer: { // 坐标轴指示器，坐标轴触发有效
      type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
    },
  },
  legend: {
    selectedMode: false,
    show: false
  },
  grid: {
    left: '33px',
    right: '40',
    bottom: 0,
    top: '10px',
    containLabel: true
  },
  xAxis: [{
    type: 'value',
    axisLine: {
      show: false, //隐藏x轴
      lineStyle: {
        color: ["rgba(255,255,255,0.2)"],
      },
    },
    axisTick: {
      show: false,  //刻度线
    },
    splitLine: {
      show: false,  //刻度线
    },
    axisLabel: {
      show: false,
      formatter: '{value}',
      textStyle: {
        color: '#6E7079', // 坐标轴文字颜色
        fontSize: 12, // 坐标轴文字大小
        padding: [0, 10, 0, 0]
      },
    },
  }],
  yAxis: [{
    splitLine: {
      show: false,
      lineStyle: {
        color: ["rgba(255,255,255,0.2)"],
      },
    },
    axisLine: { //y轴
      show: false,
      lineStyle: {
        color: ["rgba(255,255,255,0.2)"],
      },
    },
    type: 'category',
    axisTick: {
      show: false
    },
    data: [],
    axisLabel: {
      textStyle: {
        color: 'rgba(255,255,255,0.65)',
        fontSize: 12
      }
    }
  }],
  series: [{
    name: 'test',
    type: 'bar',
    barWidth: 40, // 柱子宽度
    label: {
      show: true,
      position: 'right', // 位置
      color: 'rgba(255,255,255,0.85)',
      fontSize: 12,
      distance: 5, // 距离
      formatter: function(params) {
        return filters.changeNum(params.value)
      }
    }, // 柱子上方的数值
    itemStyle: {
      barBorderRadius: [0, 8, 8, 0], // 圆角（左上、右上、右下、左下）
      color: function (params) {

        var colorList = ['#F76965', '#8E51DA', '#FFCA5C'];

        return colorList[params.dataIndex]

      }
    },
    data: []
  },]
}
export default option